<script lang="ts">
    import Icons from "./icons.svelte";
    import type { IconTypes } from "./icons.svelte";

    export let icon:IconTypes = 'info';
</script>

<div class="container">
    <Icons icon={icon} />
    <div>
        <slot></slot>
    </div>
</div>

<style>
    div.container {
        border-radius: 4px;
        border: 1px solid var(--background-offset);
        display: grid;
        grid-template-columns: auto auto;
        padding: 1rem;
        align-items: center;
        box-shadow: 0 4px 0 var(--background-offset);
        gap: 1rem;
        margin: 1rem 0;
    }
</style>